<template>
  <GdashTile
    icon="<path d='M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4M11,17H13V16H14A1,1 0 0,0 15,15V12A1,1 0 0,0 14,11H11V10H15V8H13V7H11V8H10A1,1 0 0,0 9,9V12A1,1 0 0,0 10,13H13V14H9V16H11V17Z' />"
    header="世帯純資産額の中央値"
  >
    <div class="tile-description">
      <p>
        純資産額の中央値は
        <b>{{ data.netWorth | format("c0") }}</b>
      </p>
    </div>
    <div class="tile-chart">
      <wj-linear-gauge
        class="gauge gauge-linear"
        :min="50000"
        :max="150000"
        :value="data.netWorth"
        :showTicks="true"
        :showRanges="false"
        :tickSpacing="25000"
      >
        <wj-range :min="0" :max="300000" :color="palette[0]" />
      </wj-linear-gauge>
    </div>
  </GdashTile>
</template>

<script>
import GdashTile from "./GdashTile.vue";
import * as wjcCore from "@mescius/wijmo";

export default {
  name: "NetWorthTile",
  components: {
    GdashTile,
  },

  props: {
    data: Object,
    palette: Array,
  },
  filters: {
    format(value, fmt) {
      return wjcCore.Globalize.format(value, fmt);
    },
  },
};
</script>
